module.exports = __webpack_public_path__ + "media/TOSOLA_comic.d8c7b1ac.webm";